import React from 'react';
import { ProductResponse } from '@ydistri/api-sdk';
import { useApplicationConfiguration } from '../../../hooks/useApplicationConfiguration';
import Identifications from '../Identifications/Identifications';
import {
  useIdentificationItems,
  UseIdentificationItemsParams,
} from '../Identifications/useIdentificationItems';

interface ProductIdentificationsProps {
  product: Pick<ProductResponse, 'id' | 'customerId' | 'code'>;
  systemIdMode?: UseIdentificationItemsParams['systemIdMode'];
}

const ProductIdentifications: React.FC<ProductIdentificationsProps> = ({
  product,
  systemIdMode,
}) => {
  const { displayProductId } = useApplicationConfiguration();

  const identifications = useIdentificationItems({
    displayId: displayProductId,
    entityId: product.id,
    entityCode: product.code,
    entityCustomerId: product.customerId,
    systemIdMode: systemIdMode,
  });

  return <Identifications items={identifications} />;
};

export default React.memo(ProductIdentifications);
